import React from 'react'

import "./Resources.css"


export default function Resources(props) {
  

  return (
    <>
     
    <div className={`slider-2 ${props.show ? "active" : ""}`} >
      <div className='campus-1'>
        <h1>Campus-trees</h1>
        <h1>Trees-map</h1>
      </div>

    </div>
    </>
  )
}
